var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kd-footer"},[_c('div',{staticClass:"kd-content"},[_c('div',{staticClass:"kd-clearfix"}),_c('div',{staticClass:"kd-footer__copyright"},[_c('span',{attrs:{"id":"copyrightYear"}},[_vm._v("2023")]),_vm._v(" © Bản quyền thuộc về logtracing.com\n    ")])])])
}]

export { render, staticRenderFns }